import { Controller } from "@hotwired/stimulus";

export default class LessonFormController extends Controller {
  static targets = [ 'virtualInfo' ]

  initialize() {
    console.log("Hello, Lesson Form", this.element, this.virtualInfoTarget);

    // if (this.element.dataset.returnUrl == null) {
    //   throw "Please add the return url in the Form, example: <form data-return-url='https://example.org'>";
    // }
  }

  connect() {
    this.toggleVirtualFieldset();
  }

  get form() {
    return this.element;
  }

  onChange(e) {
    const target = e.target;
    if (target.type === 'checkbox') {
      this.toggleVirtualFieldset();
    }
  }

  toggleVirtualFieldset() {
    const formData = new FormData(this.form);
    const selectedActivities = formData.getAll('lesson[activities][]').map((string) => JSON.parse(string));
    console.log('selected activities', selectedActivities);
    console.log('any Lesson Virtual', this.anyLessonVirtual(selectedActivities));

    if (this.anyLessonVirtual(selectedActivities)) {
      this.virtualInfoTarget.classList.remove('d-none');
    } else {
      this.virtualInfoTarget.classList.add('d-none');
    }
  }

  anyLessonVirtual(selectedActivities) {
    for (const selectedActivity of selectedActivities) {
      if (selectedActivity.virtual) {
        return true;
      }
    }
    return false;
  }
}
